import { Card, CardContent, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CategoryChip } from "@/components/CategoryChip";
import { TimeAgo } from "@/components/TimeAgo";
import { hr } from "@/constants/strings.hr";
import type { Article } from "@/types";

export function ArticleCard({ article }: { article: Article }) {
  const navigate = useNavigate();

  return (
    <Card
      variant="outlined"
      sx={{ cursor: "pointer", height: "100%" }}
      onClick={() => navigate(`/clanak/${article.id}`)}
    >
      <CardContent
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <CategoryChip name={article.category.name} />
        <Typography
          variant="h6"
          sx={{
            mt: 1.5,
            mb: 1,
            lineHeight: 1.3,
            "&:hover": { color: "secondary.main" },
          }}
        >
          {article.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 2,
            flex: 1,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {article.subtitle}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
            }}
          >
            {hr.article.byline}
          </Typography>
          <TimeAgo date={article.createdAt} />
        </Box>
      </CardContent>
    </Card>
  );
}
